import { WritingSection } from './WritingSection'
import { withWritingSection } from './withWritingSection'

const ConnectedWritingSection = withWritingSection(WritingSection)

export { ConnectedWritingSection as WritingSection }
